import { Component,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NavigationEnd, RouterOutlet } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { Meetup } from './mitevents.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  //  schemas:[CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent {
  
  title = 'MITAngular';
  showFooter: boolean = true;
  meetups: Meetup[] = [];
  events: any[] = [];
  constructor(private router: Router) {
  
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) { // Ensure we only react to navigation end events
        this.updateFooterVisibility(event.url);
      }
      
    
    });
  }
  ngOnInit(): void {
    // Initial check in case the application loads directly on a route that should hide the footer
    this.updateFooterVisibility(this.router.url);
  }
  private updateFooterVisibility(url: string): void {
    if ( url.includes('/mitevents')) {
      this.showFooter = false;
      // console.log(this.showFooter,"footer")
    } else {
      this.showFooter = true;
      // console.log(this.showFooter,"footer")

    }
  }
}
